<app-payment-panel-adyen-generic
  type="paypal"
  [isPayButtonVisible]="false"
  [clientKey]="clientKey"
  [paymentMethodPaypalAvailable]="paymentMethodPaypalAvailable"
  paymentMethodHandle="ADYEN_PAYPAL"
>
  <app-payment-panel-button-skeleton loadingState></app-payment-panel-button-skeleton>
</app-payment-panel-adyen-generic>
